// File: src/components/EventPreview/EventHeader.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LuArrowLeft, LuShare2 } from 'react-icons/lu';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import EventHelpTooltip from './EventHelpTooltip';
import { ReactComponent as TribeLogo } from './../../assets/TribeLogo.svg';

const S = {
  header: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    width: '100%',
    background: '#fff',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  row: {
    // back (start) • logo (center) • actions (end)
    maxWidth: 1200,
    margin: '0 auto',
    height: 56,
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '1fr auto 1fr',
    padding: '0 12px',
  },
  backBtn: {
    justifySelf: 'start',
    background: '#0b0b0b',
    color: '#fff',
    border: 'none',
    borderRadius: 9999,
    width: 40,
    height: 26,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  logoWrap: {
    justifySelf: 'center',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none',
  },
  logoSvg: {
    width: 72,
    height: 'auto',
    display: 'block',
  },
  rightWrap: {
    justifySelf: 'end',
    display: 'flex',
    alignItems: 'center',
    height: 32,
    gap: 8,
  },

  // Actions
  iconBtn: {
    width: 28,
    height: 28,
    borderRadius: 9999,
    border: '1px solid #eee',
    borderColor: '#eee',   // keep default border light on unsave
    background: '#fff',
    color: '#0b0b0b',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background .15s ease, color .15s ease, border-color .15s ease',
    outline: 'none',
  },
  shareBtn: { marginLeft: 2 },
  saveActive: {
    background: '#E53935',
    borderColor: '#E53935',
    color: '#fff',
  },
};

export default function EventHeader({
  onBack,
  isSaved = false,
  onToggleSave, // pass your existing handleSave from the parent when on Event Preview
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Show full action set ONLY on Event Preview route: /events/:eventId
  const isEventPreview = /^\/events\/[^/]+$/.test(pathname);

  const handleBack = () => (onBack ? onBack() : navigate(-1));

  const handleShare = async () => {
    try {
      const url =
        (typeof window !== 'undefined' && window.location?.href) || '';
      const title =
        (typeof document !== 'undefined' && document.title) || 'Tribe Event';

      if (typeof navigator !== 'undefined' && navigator.share) {
        await navigator.share({ title, url });
      } else if (
        typeof navigator !== 'undefined' &&
        navigator.clipboard &&
        window.isSecureContext
      ) {
        await navigator.clipboard.writeText(url);
      } else {
        const el = document.createElement('input');
        el.value = url;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
    } catch {
      // user cancelled or unsupported; no-op
    }
  };

  const handleSaveClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof onToggleSave === 'function') onToggleSave(e);
  };

  return (
    <div style={S.header}>
      <div style={S.row}>
        <button type="button" style={S.backBtn} onClick={handleBack} aria-label="Back">
          <LuArrowLeft size={16} />
        </button>

        <div style={S.logoWrap}>
          <TribeLogo style={S.logoSvg} />
        </div>

        <div style={S.rightWrap}>
          {isEventPreview ? (
            <>
              {/* Save / Unsave */}
   {/*
<button
  type="button"
  onClick={handleSaveClick}
  aria-pressed={isSaved}
  aria-label={isSaved ? 'Unsave event' : 'Save event'}
  title={isSaved ? 'Unsave' : 'Save'}
  style={{ ...S.iconBtn, ...(isSaved ? S.saveActive : null) }}
>
  {isSaved ? (
    <FaHeart style={{ width: 14, height: 14, flexShrink: 0 }} />
  ) : (
    <FaRegHeart style={{ width: 14, height: 14, flexShrink: 0 }} />
  )}
</button>
*/}
              {/* Share */}
              <button
  type="button"
  style={{ ...S.iconBtn, ...S.shareBtn }}
  onClick={handleShare}
  aria-label="Share event"
  title="Share"
>
  <LuShare2 style={{ width: 14, height: 14, flexShrink: 0 }} />
</button>

              <EventHelpTooltip
                title="About this page"
                body="See event information and actions here."
              />
            </>
          ) : (
            // On all other pages: tooltip only
            <EventHelpTooltip
              title="About this page"
              body="See information and tips for this screen."
            />
          )}
        </div>
      </div>
    </div>
  );
}
